import type { ReactNode } from "react";

import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export type VoltFigure = {
  label: ReactNode;
  value: ReactNode;
  note?: ReactNode;
  warn?: boolean;
};

/** Key figures in a box of their own above a list. */
export const VoltFigures = ({
  items,
  label = "Kennzahlen",
  className,
}: {
  items: VoltFigure[];
  label?: string;
  className?: string;
}) => (
  <Card role="region" aria-label={label} className={cn("py-4", className)}>
    <CardContent className="flex flex-wrap gap-x-10 gap-y-3">
      {items.map((f, i) => (
        <div key={i}>
          <p className="text-xs text-muted-foreground">{f.label}</p>
          <p
            className={cn(
              "text-lg font-semibold tabular-nums",
              f.warn && "text-destructive",
            )}
          >
            {f.value}
          </p>
          {f.note ? (
            <p className="text-xs text-muted-foreground tabular-nums">
              {f.note}
            </p>
          ) : null}
        </div>
      ))}
    </CardContent>
  </Card>
);
